import { select, takeEvery } from 'redux-saga/effects';

import { store } from '@redux/storeConfig/store';
import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../actions/workplansComments';
import * as selectors from '../../reducers/workplansComments';
import * as schemas from '../../schemas/workplansComments';
import {
  deleteCommentService,
  getWorkplanCommentsListService,
  saveCommentService
} from '../../services/workplansComments';
import * as types from '../../types/workplansComments';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchCommentsList(action) {
  const { visitId, locationId } = action.payload;

  getWorkplanCommentsListService(
    { visitId, locationId },
    {
      successAction: (response) => {
        const resultData = response.data.map((result) => camelcaseKeys(result));
        const {
          entities: { comments },
          result //order
        } = normalize(resultData, schemas.comments); //normalize data to byId and order
        store.dispatch(actions.completeFetchingComments(comments, result));
      },
      errorAction: (error) => {
        store.dispatch(actions.failFetchingComments(error));
      }
    }
  );
}

export function* watchFetchWorkplansCommentsList() {
  yield takeEvery(types.WORKPLAN_COMMENTS_FETCH_STARTED, fetchCommentsList);
}

/* -------------------------------------------------------------------------- */
/*                                     ADD                                    */
/* -------------------------------------------------------------------------- */
function* addComment(action) {
  const comment = action.payload;
  saveCommentService(
    { ...comment, commentId: null },
    {
      successAction: (response) => {
        const addedComment = camelcaseKeys(response.data);
        store.dispatch(actions.completeAddingComment(comment.commentId, addedComment));
      },
      errorAction: (error) => {
        store.dispatch(actions.failAddingComment(comment.commentId, error));
      }
    }
  );
}

export function* watchAddWorkplansCommentStarted() {
  yield takeEvery(types.WORKPLAN_COMMENT_ADD_STARTED, addComment);
}

/* -------------------------------------------------------------------------- */
/*                                   REMOVE                                   */
/* -------------------------------------------------------------------------- */
function* removeComment(action) {
  const { commentId } = action.payload;
  const deletedComment = yield select((state) => selectors.getWorkplansComment(state, commentId));
  deleteCommentService(
    { ...deletedComment },
    {
      successAction: (response) => {
        store.dispatch(actions.completeRemovingComment(commentId));
      },
      errorAction: (error) => {
        store.dispatch(actions.failRemovingComment(commentId, error));
      }
    }
  );
}

export function* watchRemoveWorkplansCommentStarted() {
  yield takeEvery(types.WORKPLAN_COMMENT_REMOVE_STARTED, removeComment);
}
